import { Phone, Mail, ArrowUpRight } from "lucide-react";

const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_c6eec58c-238b-4337-9d43-c824e890ecf6/artifacts/f0e7ezix_image_7f0b2b8d.jpg";

export const Footer = () => (
  <footer className="bg-[#070b14] border-t border-white/10 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-white/8">
        <div>
          <img
            data-testid="footer-logo"
            src={LOGO}
            alt="Majisa Man Power Service"
            className="h-14 w-auto rounded-md bg-white/95 px-2 py-1 object-contain mb-5"
          />
          <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
            Verified blue-collar logistics and in-store manpower. Salary-based staffing built for high-volume delivery operations.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-slate-400 mb-5">Navigate</p>
          <div className="space-y-3">
            {[
              ["Services", "#services"],
              ["Process", "#process"],
              ["Why Us", "#why-us"],
              ["Hire Manpower", "#enquire"],
              ["Contact", "#contact"],
            ].map(([label, href]) => (
              <a key={href} href={href} className="group flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#d4af37] transition-colors duration-300">
                {label}
                <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-slate-400 mb-5">Reach Us</p>
          <div className="space-y-3 text-sm text-slate-500">
            <a href="tel:+918079090643" className="flex items-center gap-2.5 hover:text-[#d4af37] transition-colors duration-300">
              <Phone className="w-4 h-4 text-[#d4af37]" /> +91 80790 90643
            </a>
            <a href="mailto:majisapowermanservice@gmail.com" className="flex items-center gap-2.5 hover:text-[#d4af37] transition-colors duration-300 break-all">
              <Mail className="w-4 h-4 text-[#d4af37] shrink-0" /> majisapowermanservice@gmail.com
            </a>
            <p className="pt-3 text-xs text-slate-600 leading-relaxed">
              Masjid Wali Gali 8, Takhatgarh, Pali, Rajasthan 306912
            </p>
          </div>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p data-testid="footer-copyright" className="text-xs text-slate-600">
          © {new Date().getFullYear()} Majisa Man Power Service. All rights reserved.
        </p>
        <p className="text-xs text-slate-600 tracking-wide">
          GSTIN 08BXLPV7721E1Z1 · PAN BXLPV7721E1Z1
        </p>
      </div>
    </div>
  </footer>
);
